import { apiWobaInventory } from "@/services/api-woba-inventory";
import { AmenitiesData } from "@/components/amenities-form/amenities-form.types";

interface LoaderData {
  amenitiesData: AmenitiesData | null;
  error?: string;
}

// Function to fetch amenities from API
const fetchAmenitiesData = async (): Promise<AmenitiesData | null> => {
  try {
    const response = await apiWobaInventory.get("/amenities-form");
    // Transform the response: API returns array directly, we need {amenities: array} format
    const transformedData = {
      amenities: response.data,
    };
    return transformedData;
  } catch (error) {
    console.error(
      "API Woba Inventory - Error fetching amenities in loader:",
      error,
    );
    return null;
  }
};

export const newCreatePrivateOfficeLoader = async (): Promise<LoaderData> => {
  try {
    // Fetch amenities data
    const amenitiesData = await fetchAmenitiesData();

    return {
      amenitiesData,
    };
  } catch (error) {
    console.error("API Woba Inventory - Error in new-create loader:", error);

    return {
      amenitiesData: null,
      error: error instanceof Error ? error.message : "Erro desconhecido",
    };
  }
};
